'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var log = debug('dns-over-http-resolver');
log.error = debug('dns-over-http-resolver:error');

var Receptacle = require('receptacle');

var utils = require('./utils');
/**
 * DNS over HTTP resolver.
 * Uses a list of servers to resolve DNS records with HTTP requests.
 */


var Resolver = /*#__PURE__*/function () {
  /**
   * @class
   * @param {object} [properties]
   * @param {number} [properties.maxCache = 100] - maximum number of cached dns records.
   */
  function Resolver() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$maxCache = _ref.maxCache,
        maxCache = _ref$maxCache === void 0 ? 100 : _ref$maxCache;

    _classCallCheck(this, Resolver);

    this._cache = new Receptacle({
      max: maxCache
    });
    this._servers = ['https://cloudflare-dns.com/dns-query', 'https://dns.google/resolve'];
  }
  /**
   * Get an array of the IP addresses currently configured for DNS resolution.
   * These addresses are formatted according to RFC 5952. It can include a custom port.
   *
   * @returns {Array<string>}
   */


  _createClass(Resolver, [{
    key: "getServers",
    value: function getServers() {
      return this._servers;
    }
    /**
     * Get a shuffled array of the IP addresses currently configured for DNS resolution.
     * These addresses are formatted according to RFC 5952. It can include a custom port.
     *
     * @returns {Array<string>}
     */

  }, {
    key: "_getShuffledServers",
    value: function _getShuffledServers() {
      var newServers = [].concat(this._servers);

      for (var i = newServers.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * i);
        var temp = newServers[i];
        newServers[i] = newServers[j];
        newServers[j] = temp;
      }

      return newServers;
    }
    /**
     * Sets the IP address and port of servers to be used when performing DNS resolution.
     *
     * @param {Array<string>} servers - array of RFC 5952 formatted addresses.
     */

  }, {
    key: "setServers",
    value: function setServers(servers) {
      this._servers = servers;
    }
    /**
     * Uses the DNS protocol to resolve the given host name into the appropriate DNS record.
     *
     * @param {string} hostname - host name to resolve.
     * @param {string} [rrType = 'A'] - resource record type.
     * @returns {Promise<*>}
     */

  }, {
    key: "resolve",
    value: function resolve(hostname) {
      var rrType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'A';

      switch (rrType) {
        case 'A':
          return this.resolve4(hostname);

        case 'AAAA':
          return this.resolve6(hostname);

        case 'TXT':
          return this.resolveTxt(hostname);

        default:
          throw new Error("".concat(rrType, " is not supported"));
      }
    }
    /**
     * Uses the DNS protocol to resolve the given host name into IPv4 addresses.
     *
     * @param {string} hostname - host name to resolve.
     * @returns {Promise<Array<string>>}
     */

  }, {
    key: "resolve4",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(hostname) {
        var recordType, cached, _iterator, _step, server, response, d, data, ttl;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                recordType = 'A';
                cached = this._cache.get(utils.getCacheKey(hostname, recordType));

                if (!cached) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", cached);

              case 4:
                _iterator = _createForOfIteratorHelper(this._getShuffledServers());
                _context.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context.next = 27;
                  break;
                }

                server = _step.value;
                _context.prev = 9;
                _context.next = 12;
                return utils.fetch(utils.buildResource({
                  serverResolver: server,
                  hostname: hostname,
                  recordType: recordType
                }));

              case 12:
                response = _context.sent;
                _context.next = 15;
                return response.json();

              case 15:
                d = _context.sent;
                data = d.Answer.map(function (a) {
                  return a.data;
                });
                ttl = Math.min(d.Answer.map(function (a) {
                  return a.TTL;
                }));

                this._cache.set(utils.getCacheKey(hostname, recordType), data, {
                  ttl: ttl
                });

                return _context.abrupt("return", data);

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](9);
                log.error("".concat(server, " could not resolve ").concat(hostname, " record ").concat(recordType));

              case 25:
                _context.next = 7;
                break;

              case 27:
                _context.next = 32;
                break;

              case 29:
                _context.prev = 29;
                _context.t1 = _context["catch"](5);

                _iterator.e(_context.t1);

              case 32:
                _context.prev = 32;

                _iterator.f();

                return _context.finish(32);

              case 35:
                throw new Error("Could not resolve ".concat(hostname, " record ").concat(recordType));

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 29, 32, 35], [9, 22]]);
      }));

      function resolve4(_x) {
        return _resolve.apply(this, arguments);
      }

      return resolve4;
    }()
    /**
     * Uses the DNS protocol to resolve the given host name into IPv6 addresses.
     *
     * @param {string} hostname - host name to resolve.
     * @returns {Promise<Array<string>>}
     */

  }, {
    key: "resolve6",
    value: function () {
      var _resolve2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(hostname) {
        var recordType, cached, _iterator2, _step2, server, response, d, data, ttl;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                recordType = 'AAAA';
                cached = this._cache.get(utils.getCacheKey(hostname, recordType));

                if (!cached) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", cached);

              case 4:
                _iterator2 = _createForOfIteratorHelper(this._getShuffledServers());
                _context2.prev = 5;

                _iterator2.s();

              case 7:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 27;
                  break;
                }

                server = _step2.value;
                _context2.prev = 9;
                _context2.next = 12;
                return utils.fetch(utils.buildResource({
                  serverResolver: server,
                  hostname: hostname,
                  recordType: recordType
                }));

              case 12:
                response = _context2.sent;
                _context2.next = 15;
                return response.json();

              case 15:
                d = _context2.sent;
                data = d.Answer.map(function (a) {
                  return a.data;
                });
                ttl = Math.min(d.Answer.map(function (a) {
                  return a.TTL;
                }));

                this._cache.set(utils.getCacheKey(hostname, recordType), data, {
                  ttl: ttl
                });

                return _context2.abrupt("return", data);

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](9);
                log.error("".concat(server, " could not resolve ").concat(hostname, " record ").concat(recordType));

              case 25:
                _context2.next = 7;
                break;

              case 27:
                _context2.next = 32;
                break;

              case 29:
                _context2.prev = 29;
                _context2.t1 = _context2["catch"](5);

                _iterator2.e(_context2.t1);

              case 32:
                _context2.prev = 32;

                _iterator2.f();

                return _context2.finish(32);

              case 35:
                throw new Error("Could not resolve ".concat(hostname, " record ").concat(recordType));

              case 36:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 29, 32, 35], [9, 22]]);
      }));

      function resolve6(_x2) {
        return _resolve2.apply(this, arguments);
      }

      return resolve6;
    }()
    /**
     * Uses the DNS protocol to resolve the given host name into a Text record.
     *
     * @param {string} hostname - host name to resolve.
     * @returns {Promise<Array<Array<string>>>}
     */

  }, {
    key: "resolveTxt",
    value: function () {
      var _resolveTxt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(hostname) {
        var recordType, cached, _iterator3, _step3, server, response, d, data, ttl;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                recordType = 'TXT';
                cached = this._cache.get(utils.getCacheKey(hostname, recordType));

                if (!cached) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", cached);

              case 4:
                _iterator3 = _createForOfIteratorHelper(this._getShuffledServers());
                _context3.prev = 5;

                _iterator3.s();

              case 7:
                if ((_step3 = _iterator3.n()).done) {
                  _context3.next = 27;
                  break;
                }

                server = _step3.value;
                _context3.prev = 9;
                _context3.next = 12;
                return utils.fetch(utils.buildResource({
                  serverResolver: server,
                  hostname: hostname,
                  recordType: recordType
                }));

              case 12:
                response = _context3.sent;
                _context3.next = 15;
                return response.json();

              case 15:
                d = _context3.sent;
                data = d.Answer.map(function (a) {
                  return [a.data.replace(/['"]+/g, '')];
                });
                ttl = Math.min(d.Answer.map(function (a) {
                  return a.TTL;
                }));

                this._cache.set(utils.getCacheKey(hostname, recordType), data, {
                  ttl: ttl
                });

                return _context3.abrupt("return", data);

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](9);
                log.error("".concat(server, " could not resolve ").concat(hostname, " record ").concat(recordType));

              case 25:
                _context3.next = 7;
                break;

              case 27:
                _context3.next = 32;
                break;

              case 29:
                _context3.prev = 29;
                _context3.t1 = _context3["catch"](5);

                _iterator3.e(_context3.t1);

              case 32:
                _context3.prev = 32;

                _iterator3.f();

                return _context3.finish(32);

              case 35:
                throw new Error("Could not resolve ".concat(hostname, " record ").concat(recordType));

              case 36:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 29, 32, 35], [9, 22]]);
      }));

      function resolveTxt(_x3) {
        return _resolveTxt.apply(this, arguments);
      }

      return resolveTxt;
    }()
  }]);

  return Resolver;
}();

Resolver.Resolver = Resolver;
module.exports = Resolver;